// src/utils/activeFlow.ts
import type { FlowId } from './frameFlowMap';

const KEY = 'active_flow_id';

export function setActiveFlowId(flowId: FlowId | string) {
  if (!flowId) return;
  sessionStorage.setItem(KEY, String(flowId));
}

export function getActiveFlowId(): string | null {
  return sessionStorage.getItem(KEY);
}

export function clearActiveFlowId() {
  sessionStorage.removeItem(KEY);
}
